import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/insumo-editor";

export const Route = createFileRoute("/_authenticated/insumo-editor")({
  head: () => ({
    meta: [
      { title: "Edição de insumo — Milky Moo Palmares" },
      {
        name: "description",
        content: "Formulário de edição de insumos: custos, embalagens e validade.",
      },
      { property: "og:title", content: "Edição de insumo — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Formulário de edição de insumos: custos, embalagens e validade.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
